<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0">
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Pilih RDC Tujuan
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="col-12 pl-0 pr-0 pt-1 pb-1">
                                <v-select v-model="selectedRDC" :options="dataWarehouse" appendToBody class="font-size-10 rounded-cus focus-me" label="warehouse_name" :reduce="el => el.warehouse_id" placeholder="Pilih RDC Tujuan" @input="changeRDC" return-object>
                                    <template v-slot:no-options>
                                        Saat ini tidak ada RDC yang tersedia
                                    </template>
                                </v-select>
							</div> 
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions} from 'vuex';

export default {
	components:{
	},
	data() {
		return {
			selectedRDC: '',
		}
	},
	computed:{
		...mapState('po', ['dataWarehouse']),
	},
	methods:{
        ...mapActions('po', ['getWarehouse']),
		...mapMutations('po_cart', ['step_up', 'reset', 'setWarehouse']),

		changeRDC() {
			this.step_up()
			this.setWarehouse(this.selectedRDC)
		}
	},
	created() {
		this.getWarehouse()
		this.reset()
	}
};
</script>